export default __webpack_public_path__ + "static/media/Perennial Girdle.11e97c29.jpg";